import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "./ui/sheet";
import { useCart } from "../context/CartContext";
import { formatINR } from "../lib/api";
import { Minus, Plus, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const CartDrawer = () => {
  const { items, open, setOpen, updateQty, remove, total } = useCart();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" className="bg-mj-bg border-l border-mj-border w-full sm:max-w-md flex flex-col p-0">
        <SheetHeader className="px-6 pt-8 pb-4 border-b border-mj-border">
          <SheetTitle className="font-serif-mj text-3xl text-mj-text tracking-tight text-left">Your Selection</SheetTitle>
          <SheetDescription className="sr-only">Review the items in your cart and proceed to checkout.</SheetDescription>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          {items.length === 0 ? (
            <p data-testid="cart-empty" className="text-mj-muted text-sm mt-8 font-sans-mj">Your cart is empty. Explore the collection to begin.</p>
          ) : (
            <div className="flex flex-col divide-y divide-mj-border">
              {items.map((it) => (
                <div key={it.id} data-testid={`cart-item-${it.slug}`} className="py-5 flex gap-4">
                  <div className="w-16 h-20 bg-mj-surface border border-mj-border flex items-center justify-center shrink-0">
                    <span className="font-serif-mj text-mj-gold text-2xl">M</span>
                  </div>
                  <div className="flex-1">
                    <p className="font-serif-mj text-lg leading-tight text-mj-text">{it.name}</p>
                    <p className="text-sm text-mj-muted mt-1">{formatINR(it.price)}</p>
                    <div className="flex items-center gap-3 mt-3">
                      <button data-testid={`cart-dec-${it.slug}`} onClick={() => updateQty(it.id, it.quantity - 1)} className="w-6 h-6 border border-mj-border flex items-center justify-center hover:border-mj-red transition-colors"><Minus className="w-3 h-3"/></button>
                      <span className="text-sm w-5 text-center">{it.quantity}</span>
                      <button data-testid={`cart-inc-${it.slug}`} onClick={() => updateQty(it.id, it.quantity + 1)} className="w-6 h-6 border border-mj-border flex items-center justify-center hover:border-mj-red transition-colors"><Plus className="w-3 h-3"/></button>
                    </div>
                  </div>
                  <button data-testid={`cart-remove-${it.slug}`} onClick={() => remove(it.id)} className="text-mj-muted hover:text-mj-red self-start"><X className="w-4 h-4"/></button>
                </div>
              ))}
            </div>
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-mj-border px-6 py-6">
            <div className="flex justify-between items-baseline mb-5">
              <span className="overline text-mj-muted">Subtotal</span>
              <span data-testid="cart-total" className="font-serif-mj text-2xl text-mj-red">{formatINR(total)}</span>
            </div>
            <button data-testid="checkout-btn" onClick={() => { setOpen(false); navigate("/checkout"); }}
              className="w-full bg-mj-red text-mj-bg py-4 overline hover:bg-mj-reddark transition-colors">
              Proceed to Checkout
            </button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
